export default "__VITE_ASSET__D1TkOXy3__"